<template>
    <admin-layout class="canvas-element-preview">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1 class="mb-2">
                        {{ canvasElement.name }}
                    </h1>
                </div>
                <hr class="mb-0">
            </template>

            <section class="px-3 py-4">
                <canvas-element-preview :element="canvasElement"/>
            </section>


        </app-content-pane>
    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
import CanvasElementPreview from "@/Components/CanvasElement/CanvasElementPreview";
export default {
    name: "Show",
    components: {CanvasElementPreview, AdminLayout, AppContentPane},
    props: ['canvasElement'],
}
</script>

<style scoped>

</style>
